/**
 * Where a task lives in the app. The human tag ("AIWS-064") is preferred over
 * the uuid so a pasted link says which ticket it points at; the detail route
 * resolves either.
 */
export function taskPath(task: { id: string; identifier?: string | null }): string {
  return `/tasks/${encodeURIComponent(task.identifier ?? task.id)}`;
}

/**
 * The absolute, shareable form of `taskPath`. The signature lets the link's
 * chat preview show the task; without it the preview shows only the tag.
 */
export function taskShareUrl(task: {
  id: string;
  identifier?: string | null;
  previewToken?: string;
}): string {
  const query = task.previewToken ? `?p=${encodeURIComponent(task.previewToken)}` : '';
  return `${window.location.origin}${taskPath(task)}${query}`;
}
